<template>
  <v-container fluid>
    <h2 class="mb-5">モジュール設定</h2>

    <v-row no-gutters>
      <v-col :cols="$vuetify.display.mobile ? 12 : 3">
        <v-card :elevation="0" class="mb-3">
          <v-card-item>
            <v-card-title class="text-subtitle-2">モジュール選択</v-card-title>
          </v-card-item>

          <v-card-text>
            <v-select density="compact" hide-details="true"
              v-model:model-value="moduleID" @update:model-value="() => { configKind = [] }" :items="browsableModules"></v-select>
          </v-card-text>
        </v-card>

        <v-card v-if="!$vuetify.display.mobile || configKind.length == 0">
          <v-card-text>
            <v-list nav class="pa-0" v-model:selected="configKind" :disabled="moduleID === ''">

              <v-list-item value="basic-info">
                <v-list-item-title>チャンネル基本情報</v-list-item-title>
                <template v-slot:append>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-subheader class="mt-2">
                使用設定
              </v-list-subheader>

              <v-list-item value="usage-analog">
                <v-list-item-title>アナログ入力</v-list-item-title>
                <template v-slot:append>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-list-item>

              <v-list-item value="usage-digital">
                <v-list-item-title>デジタル入力</v-list-item-title>
                <template v-slot:append>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-list-item>

              <v-list-item value="usage-digital-output">
                <v-list-item-title>デジタル出力</v-list-item-title>
                <template v-slot:append>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-subheader class="mt-2">
                アラームメール設定
              </v-list-subheader>

              <v-list-item value="alarm-threshold">
                <v-list-item-title>閾値</v-list-item-title>
                <template v-slot:append>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-list-item>

              <v-list-item value="alarm-mailto" v-if="configurableModules.includes(moduleID)">
                <v-list-item-title>送信先</v-list-item-title>
                <template v-slot:append>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-list-item>

              <v-divider v-if="configurableModules.includes(moduleID)"></v-divider>

              <v-list-subheader class="mt-2" v-if="configurableModules.includes(moduleID)">
                アラーム出力設定
              </v-list-subheader>

              <v-list-item value="alarm-output" v-if="configurableModules.includes(moduleID)">
                <v-list-item-title>閾値</v-list-item-title>
                <template v-slot:append>
                  <v-icon>mdi-chevron-right</v-icon>
                </template>
              </v-list-item>

            </v-list>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col :cols="$vuetify.display.mobile ? 12 : 9">
        <v-card :class="{ 'ms-3': !$vuetify.display.mobile }" v-if="configKind.length >= 1">
          <v-card-text>
            <v-btn variant="text" prepend-icon="mdi-chevron-left" color="primary" class="mb-3"
              v-on:click="() => { configKind = [] }" v-if="$vuetify.display.mobile">
              設定項目の選択に戻る
            </v-btn>

            <component :is="Components[configKind[0]]"
              :module-id="moduleID"
              :is-configurable="configurableModules.includes(moduleID)"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ref, shallowRef, onMounted } from 'vue';

import axios from 'axios';

import config from '@/config.js';

import ChannelBasicInfoSetting from '../components/ChannelBasicInfoSetting.vue';
import AnalogInputUsageSetting from '../components/AnalogInputUsageSetting.vue';
import DigitalInputUsageSetting from '../components/DigitalInputUsageSetting.vue';
import DigitalOutputDataSaveSetting from '../components/DigitalOutputDataSaveSetting.vue';
import AlarmThresholdSetting from '../components/AlarmThresholdSetting.vue';
import AlarmMailToSetting from '../components/AlarmMailToSetting.vue';
import AlarmOutputSetting from '../components/AlarmOutputSetting.vue';

export default {
  name: 'ModuleSettingsView',

  setup() {

    const moduleID = ref('');
    const browsableModules = ref([
      { title: '未選択', value: '' }
    ]);

    const configurableModules = ref([]);

    const configKind = ref([]);

    const Components = shallowRef({
      'basic-info': ChannelBasicInfoSetting,
      'usage-analog': AnalogInputUsageSetting,
      'usage-digital': DigitalInputUsageSetting,
      'usage-digital-output': DigitalOutputDataSaveSetting,
      'alarm-threshold': AlarmThresholdSetting,
      'alarm-mailto': AlarmMailToSetting,
      'alarm-output': AlarmOutputSetting
    });

    onMounted(() => {
      fetchModuleList();
    });

    const fetchModuleList = () => {

      axios.get(
        config.API_URL +
        `/users/me`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("access-token") } }
      ).then((response) => {

        response.data.browsableModules.forEach((moduleID) => {
          browsableModules.value.push({
            title: moduleID,
            value: moduleID
          });
        });

        response.data.configurableModules.forEach((moduleID) => {
          configurableModules.value.push(moduleID);
        });

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };

    return {
      moduleID,
      browsableModules,

      configurableModules,

      configKind,

      Components
    }

  }
}
</script>

